import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { help } from "../utilities/api";
import "../styles/help.css";

const Help = ({ language, client, onClose, title = "" }) => {
	const [helpItems, setHelpItems] = useState(null);
	const [helpIndex, setHelpIndex] = useState(0);

	useEffect(() => {
		const loadHelp = async () => {
			const response = await help(language, client);
			setHelpItems(response);
		};
		if (language) loadHelp();

	}, [language, client]);

	const handleClick = (i) => setHelpIndex(i);


	return (
		<>
			{helpItems &&
				<Modal show={true} onHide={onClose} animation={true}>
					<Modal.Header closeButton>
						<Modal.Title>{title}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{helpItems.map((item, index) => (
							<li className={`help-link ${index === helpIndex ? "active" : ""}`} key={index} onClick={() => handleClick(index)}>
								{item.QUESTION}
								{index === helpIndex &&
									<div className='help-content'>{item.ANSWER}</div>
								}
							</li>
						))}

					</Modal.Body>
				</Modal>
			}
		</>
	);
};

export default Help;
